<div class="bw-dialog change-password-dialog">
    <lib-page-header screenName="Account" title="Change Password" subtitleText="Update your sign-in password">
        <mat-icon icon>lock</mat-icon>
        <ng-container actions>
            <button mat-flat-button color="primary"
                    (click)="changePassword()"
                    [disabled]="!canSave()">
                <mat-icon>save</mat-icon>
                Change Password
            </button>
        </ng-container>
    </lib-page-header>

    <form [formGroup]="dialogForm">
        <div class="bw-body">
            <lib-form-error-summary
                [form]="dialogForm"
                [fieldLabels]="errorFieldLabels"
                (focusField)="scrollToErrorAnchor($event)">
            </lib-form-error-summary>

            <mat-form-field [formGroup]="dialogForm" class="full-width" subscriptSizing="dynamic" appearance="outline" data-error-anchor="passwordFormControl">
                <mat-label>Password</mat-label>
                <mat-icon matPrefix class="field-icon">lock</mat-icon>
                <input [type]="passwordVisible ? 'text' : 'password'" matInput
                    placeholder="Password"
                    [formControl]="passwordFormControl"
                    minlength="{{ VALUES.USER_PASSWORD_MIN_LENGTH }}"
                    maxlength="{{ VALUES.USER_PASSWORD_MAX_LENGTH }}" />

                <button mat-icon-button matSuffix (click)="togglePasswordVisibility()"
                        [attr.aria-label]="'Show password'" type="button">
                    <mat-icon>{{ passwordVisible ? 'visibility' : 'visibility_off' }}</mat-icon>
                </button>

                <mat-hint align="start">
                    Must include: at least 1 lowercase, 1 uppercase, 1 symbol, 1 number, and be {{ VALUES.USER_PASSWORD_MIN_LENGTH }}-{{ VALUES.USER_PASSWORD_MAX_LENGTH }} characters.
                </mat-hint>
                <mat-error *ngIf="passwordFormControl.hasError('required')">Password is required.</mat-error>
                <mat-error *ngIf="passwordFormControl.hasError('minlength')">
                    Password must be at least <strong>{{ VALUES.USER_PASSWORD_MIN_LENGTH }}</strong> characters long.
                </mat-error>
                <mat-error *ngIf="passwordFormControl.hasError('maxlength')">
                    Password cannot exceed <strong>{{ VALUES.USER_PASSWORD_MAX_LENGTH }}</strong> characters.
                </mat-error>
                <mat-error *ngIf="passwordFormControl.hasError('pattern')">
                    The password must meet the following requirements:
                    <ul>
                        <li>At least <strong>1 lowercase letter</strong></li>
                        <li>At least <strong>1 uppercase letter</strong></li>
                        <li>At least <strong>1 symbol</strong> {{ "(e.g., @, $, !, %, *, #, ?, &, ^, _, -)" }}</li>
                        <li>At least <strong>1 numeric digit</strong></li>
                    </ul>
                </mat-error>
            </mat-form-field>

            <mat-form-field [formGroup]="dialogForm" class="full-width" subscriptSizing="dynamic" appearance="outline" data-error-anchor="confirmPasswordFormControl">
                <mat-label>Confirm Password</mat-label>
                <mat-icon matPrefix class="field-icon">lock_outline</mat-icon>
                <input [type]="confirmPasswordVisible ? 'text' : 'password'" matInput
                    placeholder="Confirm Password"
                    [formControl]="confirmPasswordFormControl"
                    minlength="{{ VALUES.USER_PASSWORD_MIN_LENGTH }}"
                    maxlength="{{ VALUES.USER_PASSWORD_MAX_LENGTH }}" />

                <button mat-icon-button matSuffix (click)="toggleConfirmPasswordVisibility()"
                        [attr.aria-label]="'Show password'" type="button">
                    <mat-icon>{{ confirmPasswordVisible ? 'visibility' : 'visibility_off' }}</mat-icon>
                </button>

                <mat-error *ngIf="confirmPasswordFormControl.hasError('required')">Confirm Password is required.</mat-error>
            </mat-form-field>

            <div class="form-banner-error" *ngIf="dialogForm.hasError('passwordMismatch')">
                <mat-icon>error_outline</mat-icon>
                <span>Passwords do not match.</span>
            </div>
        </div>
    </form>
</div>
